import React , {useState} from 'react'
import Navbar from '../components/home/Navbar'
import Section from '../components/Section'
import Apropos from '../components/home/Apropos'
//import Chiffre from '../components/Chiffre'
import Services from '../components/Services'
import Footer from '../components/Footer'
import ScrollToTopButton from '../components/ScrollToTopButton'
import { Helmet } from 'react-helmet';

const Home = () => {
 
  return (
    <div>
      <Helmet>
        <title>Association El-WIFAK Bargou Siliana</title>
        <meta name="description" content="L’association EL WIFAK est une association de développement qui est fondée en 1998, elle est spécialisée dans le développement économique local, l’environnement et la micro-finance." />
      </Helmet>
        <Navbar/>

        <div className='home-content'>
            <Section/>
            <div><br/></div>

            <Apropos/>
            <br/>
          
            <Services/>
           
    <div><br/></div>

        
            <Footer />
            <ScrollToTopButton />

        </div>
        
    </div>
  )
}

export default Home